const dependencies = [
  // Angular libraries
  'ngSanitize',
  'ui.router',
  'ui.bootstrap.tpls',
  'ui.bootstrap.tooltip',
  // Devex helpers
  'services.ApiService',
  'services.ChartService',
  'services.RequestHelperService',
  'services.RoutesService',
  'services.SlugAndIdService',
  'services.SpinnerService',
  'models.alertHandlingService',
  'services.ErrorReportingService',
  // Devex filters
  'filters.daysAgo',
  'filters.humanize',
  // Devex models
  'models.ConsultantMinimalModel',
  'models.JobMinimalModel',
  'models.ArticleMinimalModel',
  // Devex directives
  'directives.spinner',
  'directives.visualizations.barChart',
  'directives.visualizations.pieChart',
  'directives.visualizations.chartLabel',
  'directives.visualizations.chartLegend',
  'directives.visualizations.emptyResults',
  // Devex components
  'components.cloudinaryImage'
];

angular.module('countriesApp', dependencies);
